import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const CONTENT_BLOCKS = [
  { type: "h1", key: "parlament.title" },

  { type: "p", key: "parlament.p1", variant: "lead" },
  { type: "p", key: "parlament.p2" },

  {
    type: "list",
    titleKey: "parlament.p3",
    items: ["parlament.l1", "parlament.l2", "parlament.l3", "parlament.l4"],
  },

  { type: "p", key: "parlament.p4" },
  {
    type: "list",
    titleKey: "parlament.p5",
    items: [
      "parlament.l5",
      "parlament.l6",
      "parlament.l7",
      "parlament.l8",
      "parlament.l9",
      "parlament.l10",
    ],
  },

  { type: "p", key: "parlament.p6" },
  {
    type: "list",
    titleKey: "parlament.p7",
    items: ["parlament.l11", "parlament.l12", "parlament.l13", "parlament.l14"],
  },

  { type: "p", key: "parlament.p8" },
  {
    type: "list",
    titleKey: "parlament.p9",
    items: [
      "parlament.l15",
      "parlament.l16",
      "parlament.l17",
      "parlament.l18",
      "parlament.l19",
    ],
  },

  { type: "p", key: "parlament.p10" },
  {
    type: "list",
    titleKey: "parlament.p11",
    items: ["parlament.l20", "parlament.l21", "parlament.l21"],
  },

  {
    type: "list",
    titleKey: "parlament.p12",
    items: ["parlament.l23", "parlament.l24", "parlament.l25", "parlament.l26"],
  },

  { type: "p", key: "parlament.p13" },
  {
    type: "list",
    titleKey: "parlament.p14",
    items: [
      "parlament.l27",
      "parlament.l28",
      "parlament.l29",
      "parlament.l30",
      "parlament.l31",
      "parlament.l32",
      "parlament.l33",
      "parlament.l34",
    ],
  },

  {
    type: "list",
    titleKey: "parlament.p15",
    items: [
      "parlament.l35",
      "parlament.l36",
      "parlament.l37",
      "parlament.l38",
      "parlament.l39",
      "parlament.l40",
      "parlament.l41",
    ],
  },

  { type: "p", key: "parlament.p16" },
  { type: "p", key: "parlament.p17" },

  {
    type: "list",
    titleKey: "parlament.p18",
    items: [
      "parlament.l42",
      "parlament.l43",
      "parlament.l44",
      "parlament.l45",
      "parlament.l46",
      "parlament.l47",
      "parlament.l48",
      "parlament.l49",
      "parlament.l50",
    ],
  },

  { type: "p", key: "parlament.p19" },

  { type: "h2", key: "parlament.p20", id: "kandidature-i-izbori" },
  { type: "p", key: "parlament.p21" },

  { type: "h2", key: "parlament.p22", id: "student-prodekan" },
  { type: "p", key: "parlament.p23" },

  { type: "h2", key: "parlament.p24", id: "student-ombudsman" },
  { type: "p", key: "parlament.p25" },
];

function ListCard({ title, items }) {
  return (
    <section className="sp-card">
      <h3 className="sp-cardTitle">{title}</h3>
      <ul className="sp-list">
        {items.map((txt, idx) => (
          <li key={`${idx}-${txt}`} className="sp-listItem">
            <span className="sp-bullet" aria-hidden="true" />
            <span className="sp-listText">{txt}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}

function StudentskiParlament() {
  const [t] = useTranslation();

  return (
    <>
      <Navbar />
      <Bredcom title={t("common.home")} subtitle={t("studenti.parlament")} />

      <div className="container pt-40 pb-40">
        <div className="row">
          {/* Lijevi sadržaj — samo ovo se dizajnira */}
          <div className="col-lg-8">
            <div className="sp-scope">
              <article className="sp-article">
                {CONTENT_BLOCKS.map((b, i) => {
                  if (b.type === "h1") {
                    return (
                      <header key={`h1-${i}`} className="sp-header">
                        <h1 className="sp-title">{t(b.key)}</h1>
                        <div className="sp-divider" />
                      </header>
                    );
                  }

                  if (b.type === "h2") {
                    return (
                      <section key={`h2-${i}`} id={b.id} className="sp-section">
                        <h2 className="sp-sectionTitle">{t(b.key)}</h2>
                      </section>
                    );
                  }

                  if (b.type === "list") {
                    return (
                      <ListCard
                        key={`list-${i}`}
                        title={t(b.titleKey)}
                        items={b.items.map((k) => t(k))}
                      />
                    );
                  }

                  const pClass =
                    b.variant === "lead"
                      ? "sp-paragraph sp-lead"
                      : "sp-paragraph";

                  return (
                    <p key={`p-${i}`} className={pClass}>
                      {t(b.key)}
                    </p>
                  );
                })}
              </article>
            </div>
          </div>

          {/* Sidebar — ostaje potpuno “globalni” kao svuda */}
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">{t("sidebar.follow")}</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Facebook"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Instagram"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="YouTube"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>

              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">{t("sidebar.useful")}</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">{t("about.fpep")}</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">
                      {t("admission.Akreditacija")}
                    </Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">{t("upis.title")}</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">{t("admission.Skolarina")}</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">{t("saradnja.erasmus")}</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">{t("saradnja.projekti")}</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">{t("studenti.dom")}</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">{t("navbar.Gallery")}</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">{t("navbar.News")}</Link>
                  </li>
                </ul>
              </section>

              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">{t("sidebar.study")}</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>{t("programs.osnovne")}</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      {t("osnovne.rfb")}
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      {t("osnovne.menadzment")}
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      {t("osnovne.pravo")}
                      <br />
                    </Link>
                  </li>

                  <li>
                    <span className="post-date">
                      <strong>{t("programs.master")}</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      {t("master.poslovnaEkonomija")}
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      {t("master.ekonomijaJavnogSektora")}
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      {t("master.pravo")}
                      <br />
                    </Link>
                  </li>

                  <li>
                    <span className="post-date">
                      <strong>{t("programs.specijalisticke")}</strong> <br />
                    </span>
                    <Link to="/menadzment-javnog-sektora-specijalisticke">
                      {t("specijalisticke.mjs")}
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment-profitnog-sektora-specijalisticke">
                      {t("specijalisticke.mps")}
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default StudentskiParlament;
